<template>
  <div>
    <div class="grid-gallery gap-small">
      <div
        v-for="(image, index) in images"
        :key="image.src"
        :class="image.divClass"
      >
        <img
          class="clickable"
          :src="image.src"
          :alt="image.alt"
          @click="openGallery(index)"
        >
      </div>
    </div>
    <image-gallery v-model="galleryOpen" :images="images" :initial-index="initialIndex"/>
  </div>
</template>

<script>
import ImageGallery from "./ImageGallery";

export default {
  components: {ImageGallery},
  props: {
    images: {
      type: Array, // @type {Array<<ImageGalleryImage>}
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      initialIndex: 0,
      galleryOpen: false,
    };
  },
  methods: {
    openGallery(index) {
      this.initialIndex = index;
      this.galleryOpen = true;
    },
  },
};
</script>
